import { useCreateProductStore } from "../useCreateProductStore";

export const useRequirementPolicy = () =>
  useCreateProductStore((state) => ({
    policies: state.requirementPolicies,
    storeRequirementPolicies: state.storeRequirementPolicies,
    setDisabled: state.setDisabled,
  }));
